<script>
    import { Circle2 } from 'svelte-loading-spinners';
    import {scale} from 'svelte/transition';
</script>

<div style="position:absolute; text-align:center; left:48%; top:45%" transition:scale="{{duration: 1000}}">
    <Circle2 size="100" unit="px" colorOuter="#000100" colorCenter="#A6192E" colorInner="#DCDDDE" />
</div>